import React, { useState } from 'react';
import { Check, X, Terminal } from 'lucide-react';
import './MainMatm.css';
import { API_ENDPOINTS } from '../../../utils/apiEndpoints';
import { BASE_URL_AEPS } from '../../../utils/Constants';

export default function Aeps() {
    const [merchantTransactionId, setMerchantTransactionId] = useState("");
    const [fingpayTransactionId, setFingpayTransactionId] = useState("");
    const [transactionRrn, setTransactionRrn] = useState("");
    const [referenceId, setReferenceId] = useState("");
    const [transactionDate, setTransactionDate] = useState("");
    const [serviceType, setServiceType] = useState("");
    const [merchantId, setMerchantId] = useState("");
    const [res, setRes] = useState("00");

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [modal, setModal] = useState({ show: false, type: "", title: "", message: "" });

    const formatToCustomDate = (dateStr) => {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split('-');
        return `${day}-${month}-${year}`;
    };

    const validateForm = () => {
        const newErrors = {};
        if (!merchantTransactionId.trim()) newErrors.merchantTransactionId = "Merchant Txn ID is required";
        if (!fingpayTransactionId.trim()) newErrors.fingpayTransactionId = "Fingpay ID is required";
        if (!transactionRrn.trim()) newErrors.transactionRrn = "RRN number is required";
        if (!referenceId.trim()) newErrors.referenceId = "Reference ID is required";
        if (!transactionDate) newErrors.transactionDate = "Selection of date is mandatory";
        if (!serviceType) newErrors.serviceType = "Please select a service type";
       

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const resetForm = () => {
        setMerchantTransactionId("");
        setFingpayTransactionId("");
        setTransactionRrn("");
        setReferenceId("");
        setTransactionDate("");
        setServiceType("");
        setMerchantId("");
        setErrors({});
    };



    const handleSubmit = async () => {
        if (loading) return;
        if (!validateForm()) return;
        setLoading(true);

        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify([
                {
                merchantTransactionId: merchantTransactionId.trim(),
                fingpayTransactionId: fingpayTransactionId.trim(),
                transactionRrn: transactionRrn.trim(),
                responseCode: res,
                referenceId: referenceId.trim(),
                transactionDate: formatToCustomDate(transactionDate),
                serviceType: serviceType,
                merchantId: merchantId.trim() === "" ? null : merchantId.trim(),
                }
            ]);
 
            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(
                `${BASE_URL_AEPS}${API_ENDPOINTS.THREEWAY_RECON_MATM}`,
                requestOptions
            );

            const result = await response.json();
            console.log("api response", result);

            if (result && result.apiStatus === true) {
                setModal({
                    show: true,
                    type: "success",
                    title: "Request Completed",
                    message: result.apiStatusMessage || "Transaction verified successfully."
                });
                resetForm();
            } else {

                setModal({
                    show: true,
                    type: "error",
                    title: "Request Failed",
                    message: result.apiStatusMessage || "Something went wrong with the verification."
                });
            }

        } catch (error) {
            setModal({
                show: true,
                type: "error",
                title: "Server Error",
                message: error.message || "Server error occurred"
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="a1b2c3_la-wrapper">
            <div className="a1b2c3_la-form-card">
                <div className="a1b2c3_la-form-container">
                    <div className="a1b2c3_la-header-section">
                    <h2 className="a1b2c3_la-form-title">
                        AEPS Un-Reported Transaction
                        </h2>
                    </div>
                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Merchant Transaction ID</label>
                            <div className="a1b2c3_la-input-wrapper">
                                <input
                                    value={merchantTransactionId}
                                    onChange={(e) => {
                                        setMerchantTransactionId(e.target.value);
                                        setErrors({ ...errors, merchantTransactionId: "" });
                                    }}
                                    type="text"
                                    className="a1b2c3_la-input"
                                    placeholder="Enter Merchant Transaction ID" />
                            </div>
                            {errors.merchantTransactionId && (
                                <span className="a1b2c3_la-error-text">{errors.merchantTransactionId}</span>
                            )}
                        </div>

                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Fingpay Transaction Id</label>
                            <div className="a1b2c3_la-input-wrapper">
                                <input
                                    type="text"
                                    value={fingpayTransactionId}
                                    onChange={(e) => {
                                        setFingpayTransactionId(e.target.value);
                                        setErrors({ ...errors, fingpayTransactionId: "" });
                                    }}
                                    className="a1b2c3_la-input"
                                    placeholder="Enter Fingpay ID" />
                            </div>
                            {errors.fingpayTransactionId && (
                                <span className="a1b2c3_la-error-text">{errors.fingpayTransactionId}</span>
                            )}
                        </div>
                    </div>

                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Transaction RRN</label>
                            <div className="a1b2c3_la-input-wrapper">
                                <input
                                    type="text"
                                    value={transactionRrn}
                                    onChange={(e) => {
                                        setTransactionRrn(e.target.value);
                                        setErrors({ ...errors, transactionRrn: "" });
                                    }}
                                    className="a1b2c3_la-input"
                                    placeholder="Enter Transaction RRN" />
                            </div>
                            {errors.transactionRrn && (
                                <span className="a1b2c3_la-error-text">{errors.transactionRrn}</span>
                            )}
                        </div>
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Reference ID</label>
                            <div className="a1b2c3_la-input-wrapper">
                                <input
                                    type="text"
                                    value={referenceId}
                                    onChange={(e) => {
                                        setReferenceId(e.target.value);
                                        setErrors({ ...errors, referenceId: "" });
                                    }}
                                    className="a1b2c3_la-input"
                                    placeholder="Enter Reference ID" />
                            </div>
                            {errors.referenceId && (
                                <span className="a1b2c3_la-error-text">{errors.referenceId}</span>
                            )}
                        </div>
                    </div>

                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Select Date</label>
                            <div className="a1b2c3_la-date-wrapper">
                                <input
                                    type="date"
                                    value={transactionDate}
                                    onChange={(e) => {
                                        setTransactionDate(e.target.value);
                                        setErrors({ ...errors, transactionDate: "" });
                                    }}
                                    className="a1b2c3_la-input-date" />
                               
                            </div>
                            {errors.transactionDate && (
                                <span className="a1b2c3_la-error-text">{errors.transactionDate}</span>
                            )}
                        </div>
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Service Type</label>
                            <div className="a1b2c3_la-select-wrapper">
                                <select
                                    value={serviceType}
                                    onChange={(e) => {
                                        setServiceType(e.target.value);
                                        setErrors({ ...errors, serviceType: "" });
                                    }}
                                    className="a1b2c3_la-custom-select">
                                    <option value="" disabled>Choose a service...</option>
                                    <option value="CW">M-ATM Cash Withdrawal</option>
                                    <option value="BE">Balance Enquiry</option>
                                </select>
                               
                            </div>
                            {errors.serviceType && (
                                <span className="a1b2c3_la-error-text">{errors.serviceType}</span>
                            )}
                        </div>
                    </div>

                    <div className="a1b2c3_la-row">
                        <div className="a1b2c3_la-field-group">
                            <label className="a1b2c3_la-label">Merchant ID</label>
                            <div className="a1b2c3_la-input-wrapper">
                                <input
                                    type="text"
                                    value={merchantId}
                                    onChange={(e) =>
                                        setMerchantId(e.target.value)}
                                    className="a1b2c3_la-input"
                                    placeholder="Enter Merchant ID" />
                            </div>
                           
                        </div>
                        <div className="a1b2c3_la-field-group a1b2c3_la-desktop-only"></div>
                    </div>

                    <div className="a1b2c3_la-actions-row">
                        <button
                            className="a1b2c3_la-submit-btn-half"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? "Processing..." : 'Submit'}
                        </button>
                        <button className="a1b2c3_la-clear-btn-half" onClick={resetForm}>
                            Clear Form
                        </button>
                    </div>
                </div>
            </div>


            {modal.show && (
                <div className="x9p2_recon_modal-overlay">
                    <div className="x9p2_recon_fa-modal-content">
                        <div style={{
                            width: '70px', height: '70px', borderRadius: '50%',
                            backgroundColor: modal.type === "success" ? '#ecfdf5' : modal.type === "error" ? '#fff1f2' : '#fffbeb',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem'
                        }}>
                            {modal.type === "success" && <Check size={32} color="#10b981" strokeWidth={3} />}
                            {modal.type === "error" && <X size={32} color="#ef4444" strokeWidth={3} />}
                            {modal.type === "warning" && <Terminal size={32} color="#f59e0b" strokeWidth={3} />}
                        </div>
                        <h3 style={{ margin: '0 0 0.5rem 0', fontWeight: 'bold' }}>{modal.title}</h3>
                        <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '2rem' }}>{modal.message}</p>
                        <button
                            className="x9p2_recon_la-submit-btn-half"
                            style={{ background: modal.type === "success" ? '#10b981' : modal.type === 'error' ? '#ef4444' : '#f59e0b' }}
                            onClick={() => setModal({ ...modal, show: false })}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
